module.exports = __webpack_public_path__ + "static/media/mission.d2d91b4e.jpg";